import { render, staticRenderFns } from "./smfa-redirect.vue?vue&type=template&id=4ad84684"
import script from "./smfa-redirect.vue?vue&type=script&lang=js"
export * from "./smfa-redirect.vue?vue&type=script&lang=js"
import style0 from "./smfa-redirect.vue?vue&type=style&index=0&id=4ad84684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports